import React from 'react';

import styled from '@emotion/styled';

import * as style from './MegaMenuFooterStyle';
import MenuColumn from './menuColumn/MenuColumn';
import { footerDataType } from '../Footer';

type MegaMenuFooterDataType = {
  data: footerDataType[];
};

const Container = styled.div`
  ${style.container};
`;
const MegaMenuFooter = ({ data }: MegaMenuFooterDataType) => {
  return (
    <Container>
      {data.map(({ title, slug, items }) => {
        return (
          <MenuColumn key={title} title={title} slug={slug} items={items} />
        );
      })}
    </Container>
  );
};

export default React.memo(MegaMenuFooter);
